var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.43 23.92C19.54 23.88 19.64 23.81 19.73 23.72C19.81 23.64 19.88 23.54 19.93 23.42C19.97 23.31 20 23.19 20 23.07C20 22.95 19.97 22.83 19.93 22.72C19.88 22.6 19.81 22.5 19.73 22.42L9.46 11.99L19.73 1.57C19.9 1.4 19.99 1.16 19.99 0.92C19.99 0.67 19.9 0.44 19.73 0.27C19.56 0.09 19.33 0 19.08 0C18.84 0 18.61 0.09 18.44 0.27L7.53 11.34C7.45 11.43 7.38 11.53 7.34 11.64C7.29 11.75 7.27 11.87 7.27 11.99C7.27 12.12 7.29 12.24 7.34 12.35C7.38 12.46 7.45 12.56 7.53 12.65L18.44 23.72C18.53 23.81 18.63 23.88 18.74 23.92C18.85 23.97 18.96 24 19.08 24C19.2 24 19.32 23.97 19.43 23.92ZM12.16 23.92C12.27 23.88 12.37 23.81 12.46 23.72C12.54 23.64 12.61 23.54 12.65 23.42C12.7 23.31 12.72 23.19 12.72 23.07C12.72 22.95 12.7 22.83 12.65 22.72C12.61 22.6 12.54 22.5 12.46 22.42L2.19 11.99L12.46 1.57C12.63 1.4 12.72 1.16 12.72 0.92C12.72 0.67 12.63 0.44 12.46 0.27C12.29 0.09 12.05 0 11.81 0C11.57 0 11.34 0.09 11.17 0.27L0.26 11.34C0.18 11.43 0.11 11.53 0.06 11.64C0.02 11.75 0 11.87 0 11.99C0 12.12 0.02 12.24 0.06 12.35C0.11 12.46 0.18 12.56 0.26 12.65L11.17 23.72C11.25 23.81 11.35 23.88 11.46 23.92C11.58 23.97 11.69 24 11.81 24C11.93 24 12.05 23.97 12.16 23.92Z",
    fill: "#00A03C",
    fillOpacity: 1,
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCollapse);
export default __webpack_public_path__ + "static/media/ico_collapse.291a3cdccf8f06087cf700e088ff1f24.svg";
export { ForwardRef as ReactComponent };